import * as React from "react";
import { ITileSettings } from "components/product-collection/manage-tile-view/types";

interface IProps {
    costPrice: string;
    retailPrice: string;
    tileSettings: ITileSettings;
}

const ProductCollectionTileUnitary: React.FC<IProps> = ({ costPrice, retailPrice, tileSettings }) => {
    return (
        <React.Fragment>
            {tileSettings.showTotalCost && (
                <div>
                    <dt>{tileSettings.costLabel}</dt>:{" "}
                    <dd>
                        <strong>{costPrice}</strong>
                    </dd>{" "}
                    {costPrice && "/ea"}
                </div>
            )}
            {tileSettings.showTotalRetail && (
                <div>
                    <dt>{tileSettings.retailLabel}</dt>:{" "}
                    <dd>
                        <strong>{retailPrice}</strong>
                    </dd>{" "}
                    {retailPrice && "/ea"}
                </div>
            )}
        </React.Fragment>
    );
};

// separate export statement so function name shows up in React DevTools
export { ProductCollectionTileUnitary };
